import * as yup from "yup";

export const raiseRequestValidation = yup.object().shape({
  date: yup.date().required("Date is required"),
  head: yup.string().required("Head is required"),
  // sub_head: yup.string().required("Sub head is required"),
  quantity: yup.number().required("Quantity is required"),
  rate: yup.number().required("Rate is required"),
  tax: yup.string().required("Tax is required"),
  description: yup.string().required("Description is required"),
  amount: yup.number().required("Amount is required"),
});
